export interface SingleDateOperationPayload {
  date: Date;
}

export interface BetweenDateOperationPayload {
  start: Date;
  end: Date;
}

export type DateOperationPayload = SingleDateOperationPayload | BetweenDateOperationPayload;
